import { extend2 } from '../../../../fc-core/src/lib';

function getBaseSplinePath(a) {
  var b,
      c,
      d,
      e = a.length,
      f = [],
      g = !1,
      h = !0;

  for (d = 0; d < e; ++d) {
    if (b = a[d], h) {
      f.push(b), c = extend2([], b), h = !1;
      continue;
    }

    if ('Z' === b) {
      h = !0, g = !1, c[0] = 'L', f.push(c, 'Z');
      continue;
    }

    g || (f.push(b), b.toString() === a[d - 1].toString() && (g = !0));
  }

  return f;
}

export default {
  "*.dataset.splinearea": function datasetSplinearea() {
    return {
      "anchor.appearing": [{
        initialAttr: {
          opacity: 0
        },
        finalAttr: {
          opacity: 1
        },
        startEnd: {
          start: .5,
          end: 1
        },
        slot: 'plot'
      }],
      "anchor.updating": [{
        initialAttr: {
          opacity: 0
        },
        finalAttr: {
          opacity: 1
        },
        slot: 'final'
      }],
      "anchor.disappearing": [{
        finalAttr: {
          opacity: 0,
          "fill-opacity": 0,
          "stroke-opacity": 0
        },
        slot: 'final'
      }],
      "line.appearing": function lineAppearing(a) {
        var b = a.component,
            c = b.components.data,
            d = b.getLinePath(c, null, 'zero'),
            e = a.attr;
        return [{
          initialAttr: {
            opacity: 0,
            path: getBaseSplinePath(d.getPathArr())
          },
          finalAttr: {
            opacity: 1,
            path: e && e.path
          },
          startEnd: {
            start: 0,
            end: .5
          },
          slot: 'plot',
          hookFn: function hookFn() {
            this.attr({
              opacity: 1
            });
          }
        }];
      },
      "label.appearing": [{
        initialAttr: {
          opacity: 0
        },
        finalAttr: {
          opacity: 1
        },
        slot: 'final'
      }],
      "label.updating": function labelUpdating() {
        return [{
          initialAttr: {
            opacity: 0
          },
          finalAttr: {
            opacity: 1
          },
          slot: 'final'
        }];
      },
      "group.appearing": function groupAppearing(a) {
        return 'label-group' === a.attr.name ? [{
          initialAttr: {
            opacity: 0
          },
          finalAttr: {
            opacity: 1
          },
          slot: 'final'
        }] : 'plot-group' === a.attr.name ? [{
          initialAttr: {
            opacity: 0
          },
          finalAttr: {
            opacity: 1
          },
          startEnd: {
            start: .5,
            end: 1
          },
          slot: 'plot'
        }] : [{
          initialAttr: {
            opacity: 1
          },
          finalAttr: {
            opacity: 1
          },
          slot: 'final'
        }];
      }
    };
  }
};